import { CSSProperties } from 'react';
import { PropsWrapper } from './PropsWrapper';
import { Wrapper } from '@sharedComponents/Wrapper';
import { ButtonRecord } from '@app/Layout/Header/Desktop/HeaderMain/HeaderBottom/ButtonRecord';
import classNames from 'classnames';

import styles from './WrapperSubMenu.module.scss';

const SetCountColumns = (limit, count): number => {
  return Math.ceil(count / limit);
};

export const WrapperSubMenu = ({ children, className, limit = 10, count = 1, addButton }: PropsWrapper): JSX.Element => {
  return (
    <Wrapper className={className}>
      <div className={classNames(styles.List)} style={{ '--num': SetCountColumns(limit, count) } as CSSProperties}>
        {children}
      </div>
      {addButton === 'Автосервис' && (
        <ButtonRecord.BtnLink
          className={styles.Button}
          value="запись на автосервис"
          href="/records/service/avtoservis/"
          data-testid="headermenu-/records/service/avtoservis/"
        />
      )}
    </Wrapper>
  );
};
